export const minWidthHistorical = 896;
export const HAS_SEEN_WALKTHROUGH_KEY = 'has_seen_walkthrough';
export const LIVE_DATA_INTERVALS = 60;
export const GRAPH_CONTIGUITY_UNITS = 5;
